/* PLP (sv-main-collection): dropdown de filtros, drawer mobile e view toggle.
   Filtros/sort são server-side (links Liquid); aqui só abre/fecha e troca a view.
   A view é client-side (o Liquid não lê query params) e fica "sticky" carregando
   ?view= nos links de navegação da coleção. */
(function () {
  var root = document.querySelector('[data-sv-plp]');
  if (!root) return;

  /* ── View (?view=conforto|compacto|lista) ── */
  var params = new URLSearchParams(location.search);
  var urlView = params.get('view');
  if (urlView === 'compacto' || urlView === 'lista') root.setAttribute('data-view', urlView);
  var current = root.getAttribute('data-view') || 'conforto';

  var viewBtns = root.querySelectorAll('[data-sv-view]');
  var viewStatus = root.querySelector('[data-sv-view-status]');
  viewBtns.forEach(function (b) {
    b.setAttribute('aria-pressed', b.getAttribute('data-sv-view') === current ? 'true' : 'false');
    b.addEventListener('click', function () {
      var v = b.getAttribute('data-sv-view');
      root.setAttribute('data-view', v);
      viewBtns.forEach(function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
      var u = new URL(location.href);
      if (v === 'conforto') u.searchParams.delete('view'); else u.searchParams.set('view', v);
      history.replaceState({}, '', u);
      if (viewStatus) viewStatus.textContent = 'Visualização ' + (v === 'conforto' ? 'confortável' : v) + ' selecionada.';
    });
  });

  /* mantém a view ao navegar por filtros/sort/paginação (server ignora, JS reaplica) */
  if (current !== 'conforto') {
    root.querySelectorAll('a[href]').forEach(function (a) {
      var href = a.getAttribute('href') || '';
      if (href.indexOf('/collections/') === -1 && !a.classList.contains('sv-facet-row') &&
          !a.classList.contains('sv-plp-pagelink') && !a.classList.contains('sv-plp-chip') &&
          !a.classList.contains('sv-plp-chips__clear')) return;
      try {
        var u = new URL(href, location.origin);
        u.searchParams.set('view', current);
        a.setAttribute('href', u.pathname + u.search);
      } catch (e) { /* ignora hrefs inválidos */ }
    });
    var sortForm = root.querySelector('[data-sv-sort-form]');
    if (sortForm) {
      var h = document.createElement('input');
      h.type = 'hidden'; h.name = 'view'; h.value = current;
      sortForm.appendChild(h);
    }
  }

  /* ── Dropdowns dos pills (um aberto por vez, click-away, Esc) ── */
  function closePills(except) {
    root.querySelectorAll('.sv-pill.is-open').forEach(function (p) {
      if (p !== except) {
        p.classList.remove('is-open');
        var btn = p.querySelector('.sv-pill__btn');
        if (btn) btn.setAttribute('aria-expanded', 'false');
      }
    });
  }
  root.querySelectorAll('.sv-pill').forEach(function (pill) {
    var btn = pill.querySelector('.sv-pill__btn');
    var backdrop = pill.querySelector('.sv-pill__backdrop');
    if (btn) btn.addEventListener('click', function (e) {
      e.stopPropagation();
      var open = !pill.classList.contains('is-open');
      closePills(pill);
      pill.classList.toggle('is-open', open);
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
    if (backdrop) backdrop.addEventListener('click', function () { closePills(); });
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closePills(); });

  /* ── Drawer de filtros (mobile) ── */
  var drawer = root.querySelector('[data-sv-drawer]');
  var lastFocused;
  function closeDrawer() {
    if (!drawer || !drawer.classList.contains('is-open')) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    root.querySelectorAll('[data-sv-drawer-open]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
    document.body.style.overflow = '';
    if (lastFocused && document.contains(lastFocused)) lastFocused.focus();
  }
  root.querySelectorAll('[data-sv-drawer-open]').forEach(function (b) {
    b.addEventListener('click', function () {
      if (!drawer) return;
      lastFocused = b;
      drawer.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      b.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
      window.setTimeout(function () {
        var close = drawer.querySelector('[data-sv-drawer-close]');
        if (close) close.focus();
      }, 0);
    });
  });
  if (drawer) drawer.querySelectorAll('[data-sv-drawer-close]').forEach(function (b) {
    b.addEventListener('click', closeDrawer);
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeDrawer();
    if (e.key !== 'Tab' || !drawer || !drawer.classList.contains('is-open')) return;
    var focusable = [].slice.call(drawer.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), summary'));
    if (!focusable.length) return;
    var first = focusable[0];
    var last = focusable[focusable.length - 1];
    if (e.shiftKey && document.activeElement === first) {
      e.preventDefault();
      last.focus();
    } else if (!e.shiftKey && document.activeElement === last) {
      e.preventDefault();
      first.focus();
    }
  });
})();
